import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import CacheManagementPanel from '../../components/templates/admin/CacheManagementPanel';

const CacheManagementPage = () => {
  return (
    <AdminLayout>
      <CacheManagementPanel />
    </AdminLayout>
  );
};

export default CacheManagementPage;
